module.exports = __webpack_public_path__ + "img/methoden_320.bc2e9c45.png";